export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const processPathsForChonky = (paths, initialPath) => {
  const itemsMap = {};
  // Ensure the initialPath ends with a '/' for consistent removal
  const basePath = initialPath.endsWith('/') ? initialPath : `${initialPath}/`;

  paths.forEach(fullPath => {
    // Remove the initial path and then process
    const relativePath = fullPath.startsWith(basePath) ? fullPath.substring(basePath.length) : fullPath;
    const parts = relativePath.split('/');
    let currentPath = '';

    parts.forEach((part, index) => {
      // Build the path incrementally for each part
      currentPath = currentPath ? `${currentPath}/${part}` : part;
      const isDir = index < parts.length - 1;

      if (!itemsMap[currentPath]) {
        // Set parentId based on the path, null for top-level items
        const parentId = currentPath.includes('/') ? currentPath.substring(0, currentPath.lastIndexOf('/')) : null;

        itemsMap[currentPath] = {
          id: currentPath,
          name: part,
          isDir,
          parentId,
        };
      }
    });
  });

  // Convert the map to an array for Chonky
  return Object.values(itemsMap);
}


